import axiosPublicClient from "../../../../axiosPublicClient"

export default async (payload) => {
    const result = await axiosPublicClient.post(`/request-candidate-consumer-report-code`, payload)
    return result.data
}
